<template>
  <li class="zxzt_item">
    <router-link :to="`/zxzt_detail?id=${objItem.id}`"  target="_blank">
      <img :src="objItem.coverPath" />
      <p>{{objItem.name}}</p>
    </router-link>
  </li>
</template>

<script>
export default {
  props: {
    objItem: Object,
  },
  methods: {
    go(name, id, code) {
      this.$router.push({
        name: name,
        query: {
          id: id,
          code: code
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.zxzt_item {
  display: flex;
  margin-right: 20px;
  a {
    width: 380px;
    img {
      width: 387px;
      height: 291px;
      background: #c1cbe7;
      object-fit: cover
    }
    p {
      font-size: 16px;
      color: #333;
      padding: 19px 0 40px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: center;
    }
  }
}
.zxzt_item:nth-child(3n){
  margin-right: 0;
}
</style>
